import { useState } from 'react';
import './ImageUser.css';
import { useAuthDispatchContext } from '/src/features/auth/context/authContext';
import accountService from '../../services/accountService';
import { useToastDispatchContext } from '/src/layouts/toast/context/toastContext';
import FormData from 'form-data';

function ImageUser({image, id}) {

    const [img,setImage] = useState(image);
    const dispatch = useAuthDispatchContext();
    const toast = useToastDispatchContext();

    const onChangeImage = async (e) => {
        let file = e.target.files[0];
        const extensions =  new RegExp(`(\\.${['png','jpg','jpeg'].join('|\\.')})$`);
        if (!extensions.exec(file.name)) { 
            return false;
        }
        const formData = new FormData();
        formData.append('image', file)
        const [data, error] = await accountService.updateMyAccount(formData);
        if(error) {
            console.log(error)
            return;
        }
        setImage(data.user.picture)
        toast.success('Update Profil Picture', 'Congrats for updating your profile picture you are a wonderful customer 🎉🎉');
        sessionStorage.setItem('user', JSON.stringify(data))
        dispatch({type : 'refreshUserInfo', payload : { user : data }})
    }

    return (
        <div className="profil-picture">
            <input id="update-picture" type="file" accept=".png, .jpg, .jpeg" onChange={onChangeImage}/>
            <img src={img} height="80" width="80"/>
            <span>Change</span>
        </div>
    )
}

export default ImageUser